import { ArrowRight, ScanSearch, ShieldCheck, UsersRound, Waypoints } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { routeToIntake } from '../lib/intakeRouting';

const routes: Array<{ source: string; detail: string; icon: LucideIcon }> = [
  {
    source: 'Findable on AI',
    detail: 'Scan results can trigger AEO repair or proof stream support when evidence is thin.',
    icon: ScanSearch,
  },
  {
    source: 'viabilAIty',
    detail: 'Qualified businesses can be launched into a credible market footprint.',
    icon: ShieldCheck,
  },
  {
    source: 'Direct Macellum',
    detail: 'Trades, local services, SMEs, and founders can ask for proof-to-market help directly.',
    icon: Waypoints,
  },
  {
    source: 'Agency path',
    detail: 'Agencies can use Macellum as a proof production and fulfilment layer.',
    icon: UsersRound,
  },
];

export function MeshRouting() {
  return (
    <section
      id="mesh-routing"
      className="border-b border-white/10 bg-obsidian py-24 sm:py-28"
      data-aeo-section="mesh-routing"
      data-aeo-trigger="oxytocin"
    >
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div>
            <p className="text-sm font-black uppercase text-mint">SIDOM mesh routing</p>
            <h2 className="mt-4 text-4xl font-black leading-tight tracking-normal text-white sm:text-5xl">
              Macellum is a recipient and feeder inside the SIDOM venture mesh.
            </h2>
            <p className="mt-6 text-lg leading-8 text-ash">
              The site now treats sibling services as intelligent lead sources, not hard dependencies.
              Direct visitors can still enter the same routed intake.
            </p>
            <button
              type="button"
              onClick={() => routeToIntake({ intent: 'unsure', productHint: 'manual_review' })}
              className="mt-8 inline-flex h-12 items-center justify-center gap-2 border border-white/18 px-5 text-sm font-black uppercase text-white transition hover:border-cyan hover:text-cyan"
            >
              Talk through my setup
              <ArrowRight className="size-5" aria-hidden="true" />
            </button>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {routes.map((route) => {
              const Icon = route.icon;
              return (
                <article key={route.source} className="border border-white/12 bg-white/[0.045] p-6">
                  <Icon className="size-7 text-cyan" aria-hidden="true" />
                  <h3 className="mt-5 text-xl font-black text-white">{route.source}</h3>
                  <p className="mt-3 text-sm leading-6 text-ash">{route.detail}</p>
                </article>
              );
            })}
          </div>
        </div>

        <p className="mt-10 max-w-4xl border-l-2 border-mint pl-5 text-lg font-semibold leading-8 text-white">
          Findable diagnoses visibility. viabilAIty qualifies venture readiness. Macellum turns
          proof and public facts into market presence.
        </p>
      </div>
    </section>
  );
}
